import { render, staticRenderFns } from "./TemplatePhenomenon.vue?vue&type=template&id=6fed9b9a&"
import script from "./TemplatePhenomenon.vue?vue&type=script&lang=ts&"
export * from "./TemplatePhenomenon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports